import { createSupabaseClient } from "../../../hooks/useSupabase";

// AC49 — proactive checkout-status block, computed as soon as a Customer is
// added to the merge (mirrors mergeCustomersHandler's own checkout guard).
const checkCustomerHasCheckoutAppointment = async (
  customerId: string,
): Promise<boolean> => {
  const supabase = createSupabaseClient();

  const { count } = await supabase
    .from("appointment_customer_details")
    .select("id, appointment:appointment_id!inner(id, status)", {
      count: "exact",
      head: true,
    })
    .eq("customer_id", customerId)
    .eq("appointment.status", "checkout");

  return (count ?? 0) > 0;
};

export default checkCustomerHasCheckoutAppointment;
